import usePrivateAxios from '@/common/api/usePrivateAxios'
import { UpdateEstablishmentCompanyBranchValidationSchema } from '@/features/establishments/schemas/updateEstablishmentCompanyBranch.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

interface UseUpdateEstablishmentCompanyBranchProps {
  establishmentCompanyBranchId?: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

export const useUpdateEstablishmentCompanyBranch = ({
  establishmentCompanyBranchId,
  onSuccess,
  onError,
}: UseUpdateEstablishmentCompanyBranchProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentCompanyBranch', establishmentCompanyBranchId],
    mutationFn: async (form: UpdateEstablishmentCompanyBranchValidationSchema) => {
      const company_branch = {
        bank_account_information_attributes: {
          account: form.bank_account_information.account,
          agency: form.bank_account_information.agency,
          bank_institution_id: form.bank_account_information?.bank_institution?.value,
          payee_name: form.bank_account_information.payee_name,
          payee_cnpj: form.bank_account_information.payee_cnpj || undefined,
        },
      }

      return privateAxios.put(`/establishment/company_branches/${establishmentCompanyBranchId}`, { company_branch })
    },
    onSuccess,
    onError,
  })
}
